import React, { useState, forwardRef, useImperativeHandle } from 'react';
import { create_document, update_document } from '../api/api.js';
import { toast } from 'react-toastify';

const DocumentUpdateAllModal = forwardRef(({ isOpen, onClose }, ref) => {
  const [step, setStep] = useState(1);
  const [documentList, setDocumentList] = useState([]);
  const [docName, setDocName] = useState('');
  const [description, setDescription] = useState('');
  const [selectedTeams, setSelectedTeams] = useState([]);
  const [selectedDocuments, setSelectedDocuments] = useState([]);
  const maxDescriptionLength = 250;

  // Expose reset method to parent
  useImperativeHandle(ref, () => ({
    reset: () => {
      console.log("resetting");
      setStep(1);
      setDocName('');
      setDescription('');
      setSelectedTeams([]);
      setSelectedDocuments([]);
    },
    setup: (documents) => {
      console.log(documents);
      console.log("setupping");
      setDocumentList(documents);
    }
  }));

  //const documentList = []; //eventually this will come from outside

  const toggleTeam = (team) => {
    setSelectedTeams(prev =>
      prev.includes(team)
        ? prev.filter(t => t !== team)
        : [...prev, team]
    );
  };

  const toggleDocument = (document, index) => {
    const documentKey = `${document}_${index}`; // Use index to handle duplicates
    setSelectedDocuments(prev =>
      prev.includes(documentKey)
        ? prev.filter(d => d !== documentKey)
        : [...prev, documentKey]
    );
  };

  const toggleAllDocuments = () => {
    if (selectedDocuments.length === documentList.length) {
      // If all are selected, deselect all
      setSelectedDocuments([]);
    } else {
      // Otherwise, select all
      const allDocuments = documentList.map((doc, index) => `${doc.id}_${index}`);
      setSelectedDocuments(allDocuments);
    }
  };

  const isAllSelected = selectedDocuments.length === documentList.length;
  const selectedCount = selectedDocuments.length;

  const createDocument = () => {
    console.log("creating_document");
    console.log(docName);
    console.log(description);
    console.log(selectedTeams);
    console.log("Selected documents:", selectedDocuments);
    var data = {}
    data.name = docName;
    data.description = description;
    data.teams = selectedTeams;
    data.documents = selectedDocuments;
    console.log(data);
    create_document(data);
    onClose();
  }

  const handleNext = async() => {
    console.log(selectedDocuments);
    for(let i in selectedDocuments) {
      const docId = selectedDocuments[0].split("_")[0];
      await update_document(docId, {});
    }
    toast.success("Richiesta caricata con successo.");
    onClose();
  }

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-backdrop" onClick={onClose} />
      <div className="modal-container">
        <div className="modal-header">
          <h2 className="modal-title-document">Aggiorna documenti</h2>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>
        <div className="modal-content-large">
          <div className="modal-body">
            <div className="modal-update-subtitle">Scegli quale documento aggiornare
              <span className="modal-update-all">
                <input
                  type="checkbox"
                  name="all"
                  checked={isAllSelected}
                  onChange={toggleAllDocuments}
                /> Seleziona tutto
              </span>
            </div>
              {documentList.length ? (
                <div className="document-list">
                  <ul>
                    {documentList.map((d, index) => {
                        const documentKey = `${d.id}_${index}`;
                        return <div className="document-list-item" key={documentKey}>
                          <input
                            type="checkbox"
                            name={d.id}
                            checked={selectedDocuments.includes(documentKey)}
                            onChange={() => toggleDocument(d.id, index)}
                          /> <span>{d.name}</span>
                        </div>
                    })}
                  </ul>
                </div>
              ) : null}
          </div>
        </div>
        <div className="modal-footer">
           <button className="footer-btn btn-secondary" onClick={onClose}>Indietro</button>
            <button className="footer-btn btn-primary longbutton" onClick={handleNext}>
              Aggiorna Selezionati {selectedCount > 0 && `(${selectedCount})`}
            </button>

        </div>
      </div>
    </div>
  );
})

export default DocumentUpdateAllModal;
